import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const SarcasmApi = createApi({
  reducerPath: "SarcasmApi",
  baseQuery: authBaseQuery,

  endpoints: (builder) => ({
    getBlogById: builder.query({
      query: (id) => {
        return `v1/sarcasm/blog/${id}`;
      },
    }),
    updateBlogContent: builder.mutation({
      query: (formData) => ({
        url: `v1/sarcasm/blog/`,
        method: "PUT",
        body: formData,
      }),
    }),
    uploadImageToGCP: builder.mutation({
      query: (formData) => ({
        url: `v1/sarcasm/gcp/upload-image`,
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const { useGetBlogByIdQuery, useUpdateBlogContentMutation,useUploadImageToGCPMutation } = SarcasmApi;

export default SarcasmApi;
